import {Box, Stack, Text} from '@mantine/core';
import React from 'react';

import {MinimalFolder} from 'constants/FolderConstants';
import MultipleFolderSelector from 'file-browser/MultipleFolderSelector';
import {TagsInputSize} from 'ui-library/tags-input/TagsInputConstants';

import {EventTriggerConfig} from '../RoutineTypes';
import {FolderScopeAccessStatus} from './useFolderScopeAccess';

interface LocationScopeSectionProps {
  accessStatus: FolderScopeAccessStatus;
  allFolders?: Array<MinimalFolder>;
  config: Partial<EventTriggerConfig>;
  onChange: (updates: Partial<EventTriggerConfig>) => void;
}

export default function LocationScopeSection({
  accessStatus,
  allFolders,
  config,
  onChange,
}: LocationScopeSectionProps): JSX.Element {
  const folderCount = config.folder_ids?.length ?? 0;
  const readOnlyMessage = `Limited to ${folderCount} ${
    folderCount === 1 ? 'project or folder' : 'projects or folders'
  }.`;

  return (
    <Box ml="lg">
      <Stack spacing={4}>
        <Text size="md" c="dimmed">
          Limit scope to...
        </Text>
        {accessStatus === 'accessible' ? (
          <MultipleFolderSelector
            // TODO(nweeden): Supplying allFolders bypasses showRegistries; refactor this before enabling registry folders.
            allFolders={allFolders}
            includeHiddenProjects={true}
            selectedFolderIds={config.folder_ids ?? []}
            onSelectFolders={(folders) => {
              onChange({folder_ids: folders.map((folder) => folder.api_identifier)});
            }}
            showNotebook={true}
            showInventory={true}
            showRegistries={false}
            placeHolderText={(config.folder_ids?.length ?? 0) === 0 ? 'All projects and folders' : ''}
            tagsInputSize={TagsInputSize.MEDIUM}
          />
        ) : (
          <Text size="sm" c="dimmed">
            {readOnlyMessage}
          </Text>
        )}
      </Stack>
    </Box>
  );
}
